import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import { store } from "./store";

// ✅ Detect react-snap prerender
const isPrerender = navigator.userAgent.includes("ReactSnap");

if (isPrerender) {
  window.snapSaveState = () => {
    return new Promise((resolve) => {
      // Give React time to render
      setTimeout(resolve, 300);
    });
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
